import * as React from 'react'
import styled from 'styled-components'

import * as hooks from '@owl-nest/hooks'
import { t, tc } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'

import * as api from '@owl-nest/api-client/latest'

type TipTaxReceiptInfoProps = {
  project: api.Project<any>
}

export function TaxDeductionModal({ project }: TipTaxReceiptInfoProps): React.ReactElement {
  const [isTaxReceiptModalOpen, setIsTaxReceiptModalOpen] = hooks.useModal('DonationTaxDeductionInfo')

  if (!project.tax_deductible) {
    return <></>
  }

  const taxDeductibleRate = Number(project?.tax_deductible_rate ?? 66)

  return (
    <ModalWithIcon
      open={isTaxReceiptModalOpen}
      closable
      onClose={() => setIsTaxReceiptModalOpen(false)}
      buttons={[
        {
          type: 'button',
          props: {
            kind: 'primary',
            type: 'button',
            onClick: () => setIsTaxReceiptModalOpen(false),
            children: t('Close'),
          },
        },
      ]}
      icon={<plume.illustrations.twoToned.SecurePaymentMedium size={127} />}
      svgScale={0.9}
    >
      <plume.styles.heading.S>
        {t('This donation is %(rate)s tax deductible', {
          rate: `${taxDeductibleRate}%`,
        })}
      </plume.styles.heading.S>

      {project.tax_receipt_enabled ? (
        <plume.styles.copy.M.light>
          {tc(
            'The owner of this fundraiser declares itself to be an organization of general interest or recognized public utility. [br][br] Following payment, you will receive by email a tax receipt that can give rise to an income tax reduction of up to %(rate)s, within the limit of %(maximumRate)s of your taxable income (only if you are taxed on income in France).',
            {
              br: <br />,
              rate: `${taxDeductibleRate}%`,
              maximumRate: '20%',
            },
          )}
        </plume.styles.copy.M.light>
      ) : (
        <plume.styles.copy.M.light>
          {tc(
            'The owner of this fundraiser declares themself as an organization of general interest or recognized public utility.[br][br]They will provide you with a tax receipt that can allow you up to a %(rate)s income tax reduction for a maximum of %(maximumRate)s of your taxable income (only if you are taxed on income in France).',
            {
              br: <br />,
              rate: `${taxDeductibleRate}%`,
              maximumRate: '20%',
            },
          )}
        </plume.styles.copy.M.light>
      )}
    </ModalWithIcon>
  )
}

const ModalWithIcon = styled(plume.ModalWithIcon)`
  ${plume.ModalIconWrapper} {
    margin-bottom: 10px;
  }

  ${plume.styles.heading.S} {
    margin-bottom: 10px;
  }
`
